import PromisingCreditLines from './PromisingCreditLines';
import MembershipSourceCard from './MembershipSourceCard';
import BenefitReportsPanel from './BenefitReportsPanel';
import SubscribedVisitModal from './SubscribedVisitModal';
import PayPalSubscribeOverlay from './PayPalSubscribeOverlay';
import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import '../appComponents/desktop/css/PlatformFooterDesktop.css';
import '../appComponents/desktop/css/DesktopModalStyles.css';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import './css/SubscriptionCarouselRefinement.css';
import './css/SubscriptionSupportResponsive.css';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import React, { Component } from 'react';

class SubscriptionPlanDesktopRender extends Component {
  render() {
    const { getMembershipIdentity, API, AWS, Amplify, Auth, Bar, Button, ButtonContent, ButtonGroup, CartesianGrid, Chart, Component, Container, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PutObjectCommand, Radio, React, ResponsiveContainer, S3Client, Storage, SubscriptionPlan, ThreeDot, Tooltip, Web3, XAxis, YAxis, actionText, awsconfig, axios, blenderCommissionPublicKey, blenderPrivateKey, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, buttonText, checkValidAuthTokenIntervalPeriod_ms, cognitoID, corporateBackedUsernamesArray, costText, currentUser, currentUserCap, emailAddress, ethers, fileDialog, firstName, fundWalletPromptDidBool, initialSubscriberBoolStatus, isMobile, isSubscribedCurrentBool, lastName, managerDisplay, managerUsername, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, primaryDisplayCurrency, primaryLanguage, publicKey, region, routeProps, secondaryDisplayCurrency, secretName, that, tokenLifeTimeLimit, transactionValue, useLayoutEffect, useParams, useRef, web3 } = this.props;

    return (
(
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--subscription-plan tbp-platform--desktop"}>
              <SubscribedVisitModal open={Boolean(that.state.showSubscribedVisitModal)} onClose={() => that.setState({ showSubscribedVisitModal: false })} spanish={that.state.selectedLanguage === 'spanish'} theme={that.state.mode_light_dark} />
              <style>{`
                .tbp-platform--subscription-plan.tbp-platform--desktop .tbp-pro-carousel {
                  margin-top: calc(10vh + 36px) !important;
                } 
              `}</style>
              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            
            <head>
              <script src="https://www.gstatic.com/charts/loader.js"></script>
            </head>
            


      
              <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                  open={that.state.errorTags}
                  // open={true}
                  style={{
                  width: '25vw',
                  justifyContent: 'center',
                  alignItems: 'center',
                  }}
              >
                  <Modal.Header
                    style={{
                      paddingLeft: '7vh',
                    }}
                  >
                    
                    The Blender Platform
                  </Modal.Header>
                
                  <Modal.Content 
                  image
                  style={{
                      justifyContent: 'space-between',
                      marginBottom: '1vh',
                  }}
                  >
                  
                  <Modal.Description
                      style={{
                      width: '25vw',
                      }}
                  >
                      <Header
                      style={{
                          // left: '16vw',
                          fontSize: 20,
                          // position: 'absolute',
                          overflowY: 'hidden',
                          overflowX: 'hidden', 
                          width: '25vw',
                          marginBottom: 65,
                          paddingRight: '1vw',
                      }}
                      >
                          <p
                          style={{
                              color: 'rgba(235, 50, 38, 1)',
                              textAlign: 'left',
                              textWrap: 'wrap',
                          }}
                          >
                          {that.state.selectedLanguage == 'spanish' ? 
                              'Error:'
                                  :
                              'Error:'
                          }
                          </p>
                          <p
                          style={{
                              color: 'rgba(0, 0, 0, 1)',
                              textAlign: 'left',
                              textWrap: 'wrap',
                              fontWeight: '400',
                              fontSize: 18,
                              paddingRight: '1vw',
                          }}
                          >
                          {that.state.errorTags}
                          </p>
                      </Header>
                  </Modal.Description>
                  </Modal.Content>
                  <Button
                      content={
                          that.state.selectedLanguage == 'spanish' ? 
                          'Bueno'
                              :
                          'Okay'
                      }
                      labelPosition='right'
                      icon='checkmark'
                      onClick={() => {
                          that.setState({
                              successfulDepositOverlay: false,
                              errorTags: null
                          })
                      }}
                      positive
                      style={{
                          backgroundColor: 'rgba(0, 158, 129, 1)',
                          position: 'relative',
                          bottom: 21,
                          fontSize: 15,
                          width: '7vw',
                          marginLeft: '9vw',
                          marginRight: '9vw',
                          // left: '0vw',
                          borderRadius: 2,
                      }}
                  />
              </Modal>

              <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.uploadDocumentOverlay}
                // open={true}
                style={{
                  width: '25vw',
                  height: '25vh',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                // trigger={<Button>Show Modal</Button>}
              >

                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>

                <Modal.Content image>
                    
                  <Modal.Description>
                    <Header
                      style={{
                        left: '2vw',
                        paddingRight: '2vw',
                        position: 'absolute',
                        fontSize: 16
                      }}
                    >
                      {that.state.documentDetails}                      
                    </Header>
                    
                    <div
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        // alignItems: 'center',
                        position: 'absolute',
                        padding: "3vw",
                        bottom: 0, 
                        left: 0, 
                        right: 0,
                        width: '25vw',
                      }}
                    >
                      <Button
                        content="Close"
                        labelPosition='right'
                        icon='close'
                        onClick={() => {
                          that.setState({
                            uploadDocumentOverlay: false
                          })
                        }}
                        positive
                        style={{
                          position: 'absolute',
                          right: 35,
                          bottom: 20,
                          marginLeft: 25,
                          backgroundColor: 'rgba(204, 12, 12, 1)',
                        }}
                      />

                      <Button
                        content="Upload"
                        labelPosition='right'
                        icon='upload'
                        onClick={() => {
                            that.uploadNewVRDocument(that.state.documentName)
                        }}
                        positive
                        style={{
                          position: 'absolute',
                          left: 35,
                          bottom: 20,
                          backgroundColor: 'rgba(0, 158, 129, 1)',
                        }}
                      />
                    </div>
                  </Modal.Description>
                  
                </Modal.Content>

              </Modal>
              
              <div className="tbp-platform__sidebar" style={{
                // borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                width: '13vw',
                height: '100vh',
                margin: 0,
                left: 0,
                position: 'absolute',
                borderRightStyle: 'solid',
                borderWidth: 0.1,
                borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
                <Button
                  onClick={() => {
                    that.setState({
                      navigationDestinationObject: {
                          navigationRoute: '/home',
                      },
                    })
                  }}
                  style={{
                    position: 'relative',
                    left: '2vw',
                    top: '1vw',
                    height: '5vw',
                    width: '5vw',
                    marginBottom: '2vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                  }}
                >
                  <img 
                    // className="logoImage" 
                    src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                    style={{
                      height: '4vw',
                      width: '4vw',
                      position: 'absolute',
                      top: 7, 
                      left: 3, 
                      right: 0,
                      borderRadius: 7,
                      borderStyle: 'solid',
                      borderWidth: 0.1,
                      borderColor: 'rgba(177, 177, 177, 0.1)',
                    }}
                  />
                </Button>


                <List>
                  <ListItem
                    style={{
                      marginBottom: 10,

                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/home',
                          },
                        })
                      }}
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="home icon"/>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Activos'
                            :
                          'Accounts'
                        }
                      </p>
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/browser',
                          },
                        })
                      }}
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                      
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="search icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Buscar'
                            :
                          'Browse'
                        }
                      </p>
                      
                    </button>
                  </ListItem>

                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/newborrowingacct',
                          },
                        })
                      }}
                      className="ui huge teal button"
                        
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="newspaper icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Tomar Prestamo'
                            :
                          'Borrow Funds'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/membertransactions',
                          },
                        })
                      }}
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="wait icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Transacciones'
                            :
                          'Transactions'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      // onClick={() => {
                      //   that.setState({
                      //     navigationDestinationObject: {
                      //         navigationRoute: '/SubscriptionPlan',
                      //     },
                      //   })
                      // }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="star icon"></i>
                        &nbsp;  
                        {'Blender Pro Plus'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
                        win.focus();
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="book icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Condiciones'
                            :
                          'Terms of Use'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
                        win.focus();
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="book icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Privacidad'
                            :
                          'Privacy Policy'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                </List>



                <button 
                  
                  style={{
                    position: 'fixed',
                    bottom: 20,
                    marginBottom: 10,
                    marginLeft: 25,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                  }}
                  className="ui medium teal button"
                  onClick={() => { 
                      trackPageRequest(Auth.signOut())
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/welcome',
                        },
                      }) 
                  }}
                >
                  <p
                    style={{
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                    }}
                  >
                    <i className="sign out icon"/>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Desconectar'
                        :
                      'Sign Out'
                    }
                  </p>
                </button>
              </div>

              <div className="tbp-platform__workspace" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10, 
                justifyContent: 'center',
                alignItems: 'center',
                width: '87vw',
                height: '100vh',
                margin: 0,
                flexDirection: 'column',
                // borderStyle: 'none',
                borderWidth: 0,    
                position: 'absolute',
                left: '13vw',
                top: '0vh',
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
              

                <div className="tbp-platform__topbar" style={{
                  // backgroundColor: 'rgba(0, 158, 129, 0)',
                  // borderRadius: 10,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '87vw',
                  height: '7vh',
                  paddingLeft: '3vw',
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  paddingRight: '10vw',
                  borderBottomStyle: 'solid',
                  borderWidth: 0.1,
                  borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                }}>
                  <p 
                    style={{ 
                      textAlign: 'left',
                      textAlignVertical: 'center',
                      fontSize: 23, 
                      fontWeight: '600', 
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      marginTop: 30, 
                      marginBottom: 30,
                      // textUnderlineOffset: 3, 
                      // textDecorationLine: 'underline', 
                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                    }}
                  >
                      <span className="tbp-platform__eyebrow">THE BLENDER PLATFORM</span><span className="tbp-platform__title">{that.state.selectedLanguage === 'spanish' ? "Blender Pro Plus" : "Blender Pro Plus"}</span>  
                  </p>


                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      position: 'absolute',
                      right: 0,
                      padding: 10,
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      paddingRight: 25,
                      borderRadius: 17
                    }}
                  >
                    <Button
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/accountmanagement',
                          },
                        })
                      }}
                      style={{
                        borderBottomLeftRadius: 18,
                        borderBottomRightRadius: 5,
                        borderTopLeftRadius: 18,
                        borderTopRightRadius: 5,
                        height: '40px',
                        borderWidth: 2,
                        marginLeft: 25,
                        marginRight: 10,
                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(35, 35, 35, 1)', 
                        borderColor: 'rgba(224, 225, 226, 0)',
                        borderStyle: 'solid', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        transitionDuration: '0.4s',
                        cursor: 'pointer',
                        padding: 0,
                      }}
                    >
                      <img 
                        className="header_profileImage" 
                        width="35" 
                        height="35" 
                        src={that.state.currentUserProfilePicture}
                      />

                      <p 
                        style={{ 
                          textAlign: 'right',
                          textAlignVertical: 'center',
                          fontSize: 16, 
                          fontWeight: '600', 
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          marginLeft: 12, 
                          marginRight: 15,
                          marginTop: 5,
                          // textUnderlineOffset: 3, 
                          // textDecorationLine: 'underline', 
                          // textDecorationColor: 'rgba(255, 255, 255, 1)',
                        }}
                      >
                          {String(that.state.currentUser).toUpperCase()}
                      </p>
                    </Button>
                  </div>



                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      position: 'absolute',
                      right: 200,
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: 17,
                      backgroundColor: 'rgba(35, 35, 35, 0)',
                      borderRadius: 17,
                      width: '5vw',
                      height: '7vh', 
                    }}
                  >


                    <button
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '2.5vw',
                        height: '7vh', 
                        paddingTop: '2.5vh',
                        paddingBottom: '1vh',
                        backgroundColor: 'rgba(35, 35, 35, 0)',
                        borderStyle: 'none',
                      }}
                      onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}
                    >
                      <p style={{ 
                        justifyContent: 'center',
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                        fontWeight: '600',
                      }}>
                        <p style={{ 
                          justifyContent: 'center',
                          textAlign: 'center',
                          textAlignVertical: 'center',
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                          fontWeight: '600',
                        }}>
                          <i
                            style={{
                              fontSize: that.state.mode_light_dark == 'dark' ? 34 : 31, 
                              marginBottom: 5, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              marginLeft: 5,
                            }}
                            className={that.state.mode_light_dark == 'dark' ? "sun icon" :"moon icon"}
                          />
                        </p>
                      </p>
                    </button>

                  </div>   

                </div>

                <div className="tbp-platform__body" style={{
                  // borderRadius: 10,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '87vw',
                  height: '93vh',
                  margin: 0,
                  borderStyle: 'none',
                  borderWidth: 0,
                }}>

                  <div 
                    class="scrollNoScrollBar"
                    style={{
                      // borderRadius: 10,
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '62vw',
                      position: 'fixed',
                      left: '13vw',
                      top: '7vh',
                      // top: 0, 
                      // bottom: 0, 
                      height: '93vh',
                      marginTop: 0,
                      marginBottom: 0,
                      marginRight: 0,
                      marginLeft: '0vw',
                      borderStyle: 'none',
                      borderWidth: 0,
                      scrollbarWidth: 'none',
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      paddingTop: '24px',
                      paddingBottom: '12px'
                    }}
                  >

                    <div className="tbp-pro-panel-column tbp-pro-membership-summary" style={{width:'56vw',marginLeft:'3vw',marginTop:'1.5vh',paddingRight:'1vw',boxSizing:'border-box'}}>
                      {that.state.isSubscribedCurrentBool ? (
                        <MembershipSourceCard membership={that.state.membership} active={true} spanish={that.state.selectedLanguage === 'spanish'} />
                      ) : (
                        <PayPalSubscribeOverlay language={that.state.selectedLanguage} theme={that.state.mode_light_dark} mobile={false} disabled={Boolean(that.state.disableButtons || that.state.freezeButtonsBool)}
                          getAccountId={async () => (await getMembershipIdentity()).userId}
                          onApproved={(subscriptionId) => that.onPayPalSubscriptionApproved(subscriptionId)} />
                      )}
                    </div>

                    <div className="tbp-pro-panel-column" style={{width:'56vw',marginLeft:'3vw',marginTop:'1.5vh',paddingRight:'1vw',boxSizing:'border-box'}}>
                      <PromisingCreditLines getMembershipIdentity={getMembershipIdentity} active={Boolean(that.state.isSubscribedCurrentBool)} spanish={that.state.selectedLanguage === 'spanish'} />
                    </div>

                    <div style={{ width: '56vw', marginLeft: '3vw', marginTop: '2vh', paddingRight: '1vw' }}>
                      <BenefitReportsPanel getMembershipIdentity={getMembershipIdentity} active={Boolean(that.state.isSubscribedCurrentBool)} spanish={that.state.selectedLanguage === 'spanish'} platformBenefits={that.state.subscriberBenefitsArray} memberProfile={that.state.memberPdfProfile || { username: that.state.currentUser || '' }} />
                    </div>

                    <div
                      className="scrollContainer tbp-pro-carousel"
                      style={{
                        // objectFit: 'auto',
                        // borderStyle: 'solid',
                        zIndex: 99999,
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'relative',
                        marginTop: 'calc(10vh + 36px)',
                        // paddingBottom: '5vh',
                        borderRadius: 3, 
                        // marginLeft: 50,
                        height: '12vh',
                        // height: 700,
                        padding: 0,
                        width: '57vw',                        
                        marginLeft: '3vw',
                        overflowX: 'hidden',
                        overflowY: 'hidden',
                        // backgroundColor: 'purple',
                      }}
                    >
                      
                      <div
                        className="scrollContainer tbp-pro-benefits-track"
                        style={{
                          // objectFit: 'auto',
                          // borderStyle: 'solid',
                          zIndex: 99999,
                          display: 'flex',
                          flexDirection: 'row',
                          // backgroundColor: 'blue',
                          position: 'relative',
                          // marginTop: '10vh',
                          // paddingBottom: '5vh',
                          borderRadius: 3, 
                          // marginLeft: 50,
                          paddingRight: '2vw',
                          height: '12vh',
                          // height: 700,
                          width: '53vw',
                          marginRight: 5,    
                          // backgroundColor: 'blue',                    
                          // marginLeft: '3vw',
                          overflowX: 'scroll',
                          overflowY: 'hidden',
                          MsOverflowStyle: 'none',  /* IE and Edge */
                          scrollbarWidth: 'none',  /* Firefox */
                          scrollSnapType: 'x mandatory',

                        }}
                      >
                        
                        <div
                          style={{
                            marginLeft: 0, 
                            // width: '57vw',                        
                            height: '9vh',
                            display: 'flex',
                            flexDirection: 'row',
                            // backgroundColor: 'green',
                            paddingRight: '2vw',

                            alignItems: 'center',
                            marginRight: '2vw',
                          }}
                        >
                          <React.Fragment>
                            {
                              that.state.subscriberBenefitsArray
                              ?
                              that.state.subscriberBenefitsArray.map(item => (
                                

                                <div className="tbp-pro-benefit"
                                  id={item.itemIndex}
                                  style={{
                                      scrollSnapAlign: 'end',
                                      height: '13vh', 
                                      width: '20vw', 
                                      display: '-webkit-box',
                                      webkitLineClamp: 2, /* number of lines to show */
                                      lineClamp: 2,
                                      webkitBoxOrient: 'horizontal',
                                      flexDirection: 'row',
                                      minWidth: '13vw',
                                      // width: 'fit-content',
                                      // borderRadius: 10,
                                      paddingTop: 30,
                                      // paddingRight: 10,
                                      padding: 20,
                                      paddingBottom: 20,
                                      // paddingLeft: 15, 
                                      // borderWidth: 1,
                                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(41, 41, 44, 1)',
                                      marginRight: '1vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      overflowX: 'visible',
                                      overflowY: 'hidden',
                                      // display: 'inlineBlock',
                                  }}
                                >
                                          
                                  <p style = {{  
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(237, 237, 237, 1)',
                                    fontSize: 15,
                                    textAlign: 'left',
                                    float: 'left',
                                    marginTop: 20,
                                    // flexWrap: 'nowrap',
                                  }}>
                                      <i 
                                        className={`${item.iconNameWeb} icon`}
                                        size={18} 
                                        style={{ 
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(248, 248, 248, 1)',
                                          fontSize: 18,
                                          textAlign: 'left',
                                          // flexWrap: 'nowrap',
                                        }}
                                      />
                                      <br/>
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        item.benefitTitleSpanish
                                        :
                                        item.benefitTitleEnglish    
                                      }
                                  </p>

                                </div>

                              
                              ))
                              : 
                              null
                            } 
                          </React.Fragment>
                        </div>

                      </div>
                      
                    </div>

                    <PlatformFooter language={that.state.selectedLanguage} />

                  </div>

                  <aside className="tbp-money-rail tbp-pro-support-rail" style={{
                    backgroundColor: that.state.mode_light_dark === 'light' ? '#e5eff5' : '#282c34',
                    color: that.state.mode_light_dark === 'light' ? '#24384f' : '#f4f7fa'
                  }}>
                    <div className="tbp-pro-support-layout">
                      <h2 className="tbp-pro-support-title">
                        {that.state.selectedLanguage === 'spanish' ? 'Apoyo de Blender Pro Plus' : 'Blender Pro Plus Support'}
                      </h2>
                      <div className="tbp-pro-support-messages scrollNoScrollBar" role="log" aria-live="polite">
                        {(that.state.messageLineArray || []).map((item, index) => (
                          <div
                            key={item.messageID || item.id || index}
                            className={'tbp-pro-support-message ' + (item.senderUsername === that.state.currentUser ? 'tbp-pro-support-message--own' : '')}
                          >
                            <div className="tbp-pro-support-message-text">{item.messageText}</div>
                            <div className="tbp-pro-support-message-meta">
                              <span>- {String(item.senderUsername || '').toUpperCase()}</span>
                              <span>{String(item.timestamp || '').substr(4,3)}. {String(item.timestamp || '').substr(8,2)}, {String(item.timestamp || '').substr(11,4)}</span>
                              <span>{Number(String(item.timestamp || '').substr(16,2)) <= 12 ? Number(String(item.timestamp || '').substr(16,2)) : Number(String(Number(String(item.timestamp || '').substr(16,2)) - 12))}{String(item.timestamp || '').substr(18,3)} {Number(String(item.timestamp || '').substr(16,2)) < 12 ? 'AM' : 'PM'}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="tbp-pro-support-composer">
                        <textarea
                          className="tbp-pro-support-input"
                          placeholder={that.state.selectedLanguage === 'spanish' ? 'Escriba su mensaje a Blender Pro Plus.' : 'Type Your Message to Blender Pro Plus.'}
                          maxLength={275}
                          id="messageToReviewTeamString"
                          rows={4}
                          value={that.state.messageToReviewTeamString || ''}
                          onChange={event => that.setState({messageToReviewTeamString: event.target.value})}
                        />
                        <div className="tbp-pro-support-actions">
                          <Button
                            onClick={() => that.setState({contactReviewTeamOverlay:false,messageToReviewTeamString:null})}
                            style={{backgroundColor:'rgba(204, 12, 12, .70)',color:'#fff'}}
                          >{that.state.selectedLanguage === 'spanish' ? 'Cancelar' : 'Exit'}</Button>
                          <Button
                            onClick={() => {
                              if (that.state.messageToReviewTeamString && String(that.state.messageToReviewTeamString).length > 1) {
                                that.sendMessageToReviewTeam(that.state.messageToReviewTeamString);
                              }
                            }}
                            style={{backgroundColor:'rgba(0, 158, 129, 1)',color:'#fff'}}
                          >{that.state.selectedLanguage === 'spanish' ? 'Enviar' : 'Send'}</Button>
                        </div>
                      </div>
                    </div>
                  </aside>

                  </div>

                </div>

              </div>
        )
    );
  }
}

export default SubscriptionPlanDesktopRender;
